/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */
import classNames from 'classnames';
import { ElementType, ReactNode } from 'react';

import styles from '../../styles/typography/typography.module.css';

export interface TypographyProps {
    tag?: ElementType;
    children?: ReactNode;
    html?: string | null;
    placeholder?: boolean;
    placeholderLines?: number;
    className?: string | null;
    // autres props HTML autorisées
    [prop: string]: unknown;
}

function Typography({
    tag: Component = 'div',
    children = null,
    html = null,
    placeholder = false,
    placeholderLines = null,
    className = null,
    ...props
}: TypographyProps) {
    const withHtml = html !== null && !placeholder;
    const componentClassName = classNames([
        className,
        {
            [styles.placeholder]: placeholder,
        },
    ]);
    return withHtml ? (
        <Component
            className={componentClassName}
            dangerouslySetInnerHTML={{ __html: !placeholder ? html : null }}
            {...props}
        />
    ) : (
        <Component className={componentClassName} {...props}>
            {!placeholder ? children : null}
        </Component>
    );
}

export default Typography;
